import React from 'react';
import { translate } from 'react-i18next';
import { func } from 'prop-types';

import { Carousel } from '@snapask/common-components';

import { PrevArrow, NextArrow } from '@dragonfruit/components/Arrows';

import { TESTIMONIALS } from '@dragonfruit/constants/premiumPage';

import Testimonial from './components/Testimonial';

import styles from './TestimonialBlock.scss';

function TestimonialBlock({ t }) {
  const testimonials = t('premium.testimonial', {
    returnObjects: true,
    defaultValue: [],
  }).filter(t => t.title !== '-');

  const carouselSetting = {
    dots: true,
    speed: 500,
    infinite: true,
    draggable: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          arrows: false,
        },
      },
    ],
  };

  return (
    <section className={styles.root} id={TESTIMONIALS}>
      <Carousel settings={carouselSetting} className={styles.container}>
        {testimonials.map(t => (
          <Testimonial {...t} key={t.title} />
        ))}
      </Carousel>
    </section>
  );
}

TestimonialBlock.propTypes = {
  t: func.isRequired,
};

export default translate(['premium'])(TestimonialBlock);



// WEBPACK FOOTER //
// ./app/containers/Premium/components/TestimonialBlock/TestimonialBlock.jsx